import React from 'react'
import DeleteIcon from '../../../icons/DeleteIcon'

export const createDeleteLocationModal = (
  location,
  dayId,
  onCloseModal,
  handleDeleteLocation,
) => ({
  isOpen: true,
  title: 'Delete Mission?',
  description: (
    <span>
      Are you sure you want to delete this mission? This action cannot be
      undone.
    </span>
  ),
  buttons: [
    {
      label: 'Cancel',
      outlined: false,
      onClick: onCloseModal,
    },
    {
      label: 'Delete',
      onClick: () => handleDeleteLocation(location, dayId),
    },
  ],
  onClose: onCloseModal,
  icon: <DeleteIcon />,
})
